import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import { Dialog } from './../../common/dialog';
import { empty } from './../../../utils';

const PackingSlipModal = React.memo((props) => {
    if (props.fetchingPackingSlipData) {
        return (
            <Dialog
                name="packing-slip-modal"
                modal={false}
                actions={[]}
                contentStyle={{ width: 1000 }}
                bodyStyle={{ overflow: 'initial' }}
                className="packing-slip-dialog"
            >
                <div className="packing-slip-container">
                    <i className="fas fa-circle-notch fa-spin" /> Loading data...
                </div>
            </Dialog >
        );
    }

    const hideHandler = () => {
        props.setIdModal(null);
        props.hidePackingSlipModal();
    };

    let selectedProduct = null;
    for (const order of props.orders) {
        if (parseInt(order.id) === parseInt(props.idModal)) {
            selectedProduct = order;
            break;
        }
    }

    if (selectedProduct == null) {
        return null;
    }

    let platform = selectedProduct.platform;
    if (platform == null || platform === '' || platform === 'null') {
        platform = 'N/A';
    }

    const getLogoName = (person) => {
        if (parseInt(person.logo) === 1) {
            return 'UT Physicians';
        } else if (parseInt(person.logo) === 2) {
            if (person.isUthHouston !== undefined && person.isUthHouston != null && parseInt(person.isUthHouston) === 1) {
                return 'UTHealth Houston';
            } else {
                return 'UTHealth';
            }
        }

        return '';
    };

    const getSizeName = (size) => {
        if (size === 'XS') {
            return 'Extra Small';
        } else if (size === 'SM') {
            return 'Small';
        } else if (size === 'MD') {
            return 'Medium';
        } else if (size === 'LG') {
            return 'Large';
        } else if (size === 'XL') {
            return 'Extra Large';
        } else if (size === '2XL') {
            return '2XL';
        } else if (size === '3XL') {
            return '3XL';
        } else if (size === '4XL') {
            return '4XL';
        } else if (size === '5XL') {
            return '5XL';
        } else if (size === '6XL') {
            return '6XL';
        } else if (size === '7XL') {
            return '7XL';
        } else if (size === '8XL') {
            return '8XL';
        }

        return '';
    };

    const renderItemCheckbox = (id, key) => {
        let checked = false;
        let productIndex = -1;
        for (let i = 0; i < props.packingSlipItems.length; i++) {
            if (parseInt(props.packingSlipItems[i].id) === parseInt(id)) {
                productIndex = i;
                break;
            }
        }

        if (productIndex !== -1) {
            checked = props.packingSlipItems[productIndex].items.indexOf(key) !== -1;
        }

        return (
            <input
                type="checkbox"
                checked={checked}
                onClick={(event) => props.checkPackingSlipItem(id, key)}
            />
        );
    };

    const renderBackorder = (key) => {
        return props.packingSlipItems.indexOf(key) !== -1 ? 'No' : 'Yes';
    };

    const renderTableItems = (orderProduct) => {
        let variables = JSON.parse(orderProduct['variables']);

        if (orderProduct.product_type === 'Cards') {
            let stockColumn = null;
            if (variables.templateCode === 'p1t9') {
                if (variables.stock && variables.stock != null && variables.stock !== '') {
                    if (parseInt(variables.stock) === 1) {
                        stockColumn = <td>Good</td>;
                    } else if (parseInt(variables.stock) === 2) {
                        stockColumn = <td>Better</td>;
                    } else if (parseInt(variables.stock) === 3) {
                        stockColumn = <td>Best</td>;
                    }
                }
            } else if (variables.templateCode === 'p1t13') {
                if (variables.stock && variables.stock != null && variables.stock !== '') {
                    if (parseInt(variables.stock) === 1) {
                        stockColumn = <td>Good</td>;
                    } else if (parseInt(variables.stock) === 2) {
                        stockColumn = <td>Better</td>;
                    } else if (parseInt(variables.stock) === 3) {
                        stockColumn = <td>Best</td>;
                    }
                }
            } else if (variables.templateCode === 'p1t16') {
                if (variables.stock && variables.stock != null && variables.stock !== '') {
                    if (parseInt(variables.stock) === 1) {
                        stockColumn = <td>Good</td>;
                    } else if (parseInt(variables.stock) === 2) {
                        stockColumn = <td>Better</td>;
                    } else if (parseInt(variables.stock) === 3) {
                        stockColumn = <td>Best</td>;
                    }
                }
            }

            let cardForColumn = null;
            if (variables.name && variables.name !== '') {
                cardForColumn = <td>{variables.name}</td>;
            }

            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['templateCode'])}</td>
                    {cardForColumn}
                    <td>{orderProduct.product_size}</td>
                    {stockColumn}
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['templateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'Apparel') {
            let persons = variables.personsParsed;
            let color = variables.color;

            if (persons) {
                return persons.map((person, index1) => {
                    return person.items.map((item, index2) => {
                        let sizeName = getSizeName(item.size);
                        let logoColumn = null;
                        if (person.logo !== undefined) {
                            logoColumn = <td>{getLogoName(person)}</td>;
                        }

                        let embroideryColumn = null;
                        if (person.embroideryFirstLine !== undefined) {
                            embroideryColumn = (
                                <td>
                                    <div><b>1st Line:</b> {person.embroideryFirstLine}</div>
                                    <div><b>2nd Line:</b> {person.embroiderySecondLine}</div>
                                    <div><b>Email:</b> {person.embroideryEmail}</div>
                                </td>
                            );
                        }

                        let uthIdColumn = null;
                        let name = person.name;
                        if (person.lastName) {
                            let personNameParts = [person.name];
                            if (person.middleName !== '') {
                                personNameParts.push(person.middleName);
                            }
                            if (person['lastName'] !== '') {
                                personNameParts.push(person.lastName);
                            }
                            name = personNameParts.join(' ');

                            uthIdColumn = <td>{person.uthId}</td>;
                        }

                        return (
                            <tr key={index1 + '-' + index2}>
                                <td>{renderItemCheckbox(orderProduct.id, index1 + '-' + index2)}</td>
                                <td>{item.sku}</td>
                                <td>{name}</td>
                                {uthIdColumn}
                                {embroideryColumn}
                                {logoColumn}
                                <td>{sizeName}</td>
                                <td>{color}</td>
                                <td>{numeral(item.quantity).format('0,0')}</td>
                                <td>{renderBackorder(index1 + '-' + index2)}</td>
                            </tr>
                        );
                    });
                });
            }
        } else if (orderProduct.product_type === 'Forms') {
            if (parseInt(variables['staticTemplateCode']) === 473) {
                return (
                    <tr>
                        <td>{renderItemCheckbox(orderProduct.id, orderProduct.sku)}</td>
                        <td>{orderProduct.sku}</td>
                        <td>{variables['size']}</td>
                        <td>{variables['language']}</td>
                        <td>{variables['orientation']}</td>
                        <td>{variables['materialType']}</td>
                        <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                        <td>{renderBackorder(orderProduct.sku)}</td>
                    </tr>
                );
            } else if (parseInt(variables['staticTemplateCode']) === 647) {
                return (
                    <tr>
                        <td>{renderItemCheckbox(orderProduct.id, orderProduct.sku)}</td>
                        <td>{orderProduct.sku}</td>
                        <td>{variables['language']}</td>
                        <td>{variables['type']}</td>
                        <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                        <td>{renderBackorder(orderProduct.sku)}</td>
                    </tr>
                );
            } else {
                let printingOptionColumn = null;
                if (variables.printingOption && variables.printingOption === 'color') {
                    printingOptionColumn = <td>Color</td>;
                } else if (variables.printingOption && variables.printingOption === 'bw') {
                    printingOptionColumn = <td>Black &amp; White</td>;
                }

                let quantity = numeral(orderProduct.quantity).format('0,0') + ' bundle(s) (' +
                    numeral(orderProduct.pieces_per * orderProduct.quantity).format('0,0') + ' pieces)';

                return (
                    <tr>
                        <td>{renderItemCheckbox(orderProduct.id, orderProduct.sku)}</td>
                        <td>{orderProduct.sku}</td>
                        <td>{orderProduct.product_size}</td>
                        {printingOptionColumn}
                        <td>{quantity}</td>
                        <td>{renderBackorder(orderProduct.sku)}</td>
                    </tr>
                );
            }
        } else if (orderProduct.product_type === 'Brochures & Flyers') {
            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['brochureTemplateCode'])}</td>
                    <td>{orderProduct.product_name}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['brochureTemplateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'Stationery Envelopes') {
            let cardFor = null;
            if (variables.name && variables.name !== '') {
                cardFor = variables.name;
            }

            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['templateCode'])}</td>
                    <td>{cardFor}</td>
                    <td>{orderProduct.product_size}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['templateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'Stationery Letterheads') {
            let cardForColumn = null;
            if (variables.name && variables.name !== '') {
                cardForColumn = <td>{variables.name}</td>;
            }

            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['templateCode'])}</td>
                    {cardForColumn}
                    <td>{orderProduct.product_size}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['templateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'Pocket Folders') {
            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['templateCode'])}</td>
                    <td>{orderProduct.product_name}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['templateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'NRC') {
            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['nrcTemplateCode'])}</td>
                    <td>{orderProduct.product_name}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['nrcTemplateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'MyUTHealth') {
            let languageRow = null;
            if (parseInt(variables['myuthealthTemplateCode']) !== 9) {
                languageRow = <td>{variables['language']}</td>;
            }

            let clinicNameRow = null;
            if (variables['clinic'] !== '') {
                clinicNameRow = <td>{variables['clinic']}</td>;
            } else {
                clinicNameRow = <td>{variables['clinicName']}</td>;
            }

            let locationRow = null;
            if (variables['location'] !== '') {
                locationRow = <td>{variables['location']}</td>;
            } else {
                locationRow = <td>{variables['yourLocation']}</td>;
            }

            if (parseInt(variables['myuthealthTemplateCode']) === 10) {
                languageRow = null;
                clinicNameRow = null;
                locationRow = null;
            }

            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['myuthealthTemplateCode'])}</td>
                    {languageRow}
                    {clinicNameRow}
                    {locationRow}
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['myuthealthTemplateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'Promotional') {
            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['promotionalTemplateCode'])}</td>
                    <td>{orderProduct.sku}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['promotionalTemplateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'Notepads') {
            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['templateCode'])}</td>
                    <td>{orderProduct.product_size}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['templateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'Notecards') {
            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['templateCode'])}</td>
                    <td>{orderProduct.product_size}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['templateCode'])}</td>
                </tr>
            );
        } else if (orderProduct.product_type === 'Holiday') {
            return (
                <tr>
                    <td>{renderItemCheckbox(orderProduct.id, variables['templateCode'])}</td>
                    <td>{orderProduct.product_name}</td>
                    <td>{numeral(orderProduct.quantity).format('0,0')}</td>
                    <td>{renderBackorder(variables['templateCode'])}</td>
                </tr>
            );
        }

        return null;
    };

    const renderTables = () => {
        return props.orderProducts.map((orderProduct) => {
            return (
                <div className="tables-container">
                    <div className="product-info">
                        <div className="product-name">
                            <b>Product Name:</b> {orderProduct.product_name}
                        </div>
                        <div className="product-type">
                            <b>Product Type:</b> {orderProduct.product_type}
                        </div>
                    </div>
                    {renderTable(orderProduct)}
                </div>
            );
        });
    }

    const renderTable = (orderProduct) => {
        let thead = null;
        let variables = JSON.parse(orderProduct['variables']);

        if (orderProduct.product_type === 'Cards') {
            let stockColumn = null;
            if (variables.templateCode === 'p1t9') {
                stockColumn = <th>Stock</th>;
            }

            let cardForColumn = null;
            if (variables.name && variables.name !== '') {
                cardForColumn = <th>Card For</th>;
            }

            thead = (
                <tr>
                    <th></th>
                    {cardForColumn}
                    <th>Size</th>
                    {stockColumn}
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'Apparel') {
            let hasLogo = false;
            let hasEmbroidery = false;
            let isManager = false;
            let persons = variables.personsParsed;

            if (persons) {
                if (persons[0].logo !== undefined) {
                    hasLogo = true;
                }

                if (persons[0].embroideryFirstLine !== undefined) {
                    hasEmbroidery = true;
                }

                if (persons[0].lastName !== undefined) {
                    isManager = true;
                }

                thead = (
                    <tr>
                        <th></th>
                        <th>SKU</th>
                        <th>Name</th>
                        {isManager ? <th>UTH-ID#</th> : null}
                        {hasEmbroidery ? <th>Embroidery</th> : null}
                        {hasLogo ? <th>Logo</th> : null}
                        <th>Size</th>
                        <th>Color</th>
                        <th>Qty</th>
                        <th>Backorder</th>
                    </tr>
                );
            }
        } else if (orderProduct.product_type === 'Forms') {
            if (parseInt(variables['staticTemplateCode']) === 473) {
                thead = (
                    <tr>
                        <th></th>
                        <th>SKU</th>
                        <th>Size</th>
                        <th>Language</th>
                        <th>Orientation</th>
                        <th>Material Type</th>
                        <th>Qty</th>
                        <th>Backorder</th>
                    </tr>
                );
            } else if (parseInt(variables['staticTemplateCode']) === 647) {
                thead = (
                    <tr>
                        <th></th>
                        <th>SKU</th>
                        <th>Language</th>
                        <th>Type</th>
                        <th>Qty</th>
                        <th>Backorder</th>
                    </tr>
                );
            } else {
                let printingOptionColumn = null;
                if (variables.printingOption && variables.printingOption === 'color') {
                    printingOptionColumn = <th>Printing Option</th>;
                } else if (variables.printingOption && variables.printingOption === 'bw') {
                    printingOptionColumn = <th>Printing Option</th>;
                }

                thead = (
                    <tr>
                        <th></th>
                        <th>SKU</th>
                        <th>Size</th>
                        {printingOptionColumn}
                        <th>Qty</th>
                        <th>Backorder</th>
                    </tr>
                );
            }
        } else if (orderProduct.product_type === 'Brochures & Flyers') {
            thead = (
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'Stationery Envelopes') {
            thead = (
                <tr>
                    <th></th>
                    <th>Card For</th>
                    <th>Size</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'Stationery Letterheads') {
            let cardForColumn = null;
            if (variables.name && variables.name !== '') {
                cardForColumn = <th>Card For</th>;
            }

            thead = (
                <tr>
                    <th></th>
                    {cardForColumn}
                    <th>Size</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'Pocket Folders') {
            thead = (
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'NRC') {
            thead = (
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'MyUTHealth') {
            let languageRow = null;
            if (parseInt(variables['myuthealthTemplateCode']) !== 9) {
                languageRow = <th>Language</th>;
            }

            let clinicNameRow = <th>Clinic Name</th>;
            let locationRow = <th>Location</th>;
            if (parseInt(variables['myuthealthTemplateCode']) === 10) {
                languageRow = null;
                clinicNameRow = null;
                locationRow = null;
            }

            thead = (
                <tr>
                    <th></th>
                    {languageRow}
                    {clinicNameRow}
                    {locationRow}
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'Promotional') {
            thead = (
                <tr>
                    <th></th>
                    <th>SKU</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'Notepads') {
            thead = (
                <tr>
                    <th></th>
                    <th>Size</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'Notecards') {
            thead = (
                <tr>
                    <th></th>
                    <th>Size</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        } else if (orderProduct.product_type === 'Holiday') {
            thead = (
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Qty</th>
                    <th>Backorder</th>
                </tr>
            );
        }

        return (
            <table className="table table-sm">
                <thead>{thead}</thead>
                <tbody>{renderTableItems(orderProduct)}</tbody>
            </table>
        );
    };

    let saveButtonLabel = 'Save';
    if (props.savingPackingSlip) {
        saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    let printButtonLabel = 'Print';
    if (props.printingPackingSlip) {
        printButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    const handlePrintPackingSlip = () => {
        props.printPackingSlip(selectedProduct.id, selectedProduct.uthealth_order_id);
    };

    let actions = [
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Close</button>,
        <button key="save-button" className="btn btn-light btn-sm action-button" onClick={props.savePackingSlip} disabled={props.savingPackingSlip}>{saveButtonLabel}</button>,
        <button key="print-button" className="btn btn-light btn-sm print-button" onClick={handlePrintPackingSlip} disabled={props.printingPackingSlip}>{printButtonLabel}</button>,
    ];
    return (
        <Dialog
            name="packing-slip-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="packing-slip-dialog"
        >
            <div className="packing-slip-container">
                <div className="corporate-storefront">
                    <img src="https://ac-ut-health.s3.amazonaws.com/corporatestorefront.jpg" alt="Corporate Storefront" />
                </div>
                <div className="packing-slip">
                    <div className="header">
                        <div className="logo">
                            <img src="https://ac-ut-health.s3.amazonaws.com/absolute-color-logo.jpg" alt="Absolute Color" />
                        </div>
                        <div className="title-container">
                            <div className="title">Packing Slip</div>
                            <div className="date">{moment().format('MMMM Do YYYY')}</div>
                        </div>
                    </div>
                    <div className="details-container">
                        <div className="ship-to">
                            <h3>Ship To:</h3>
                            <div className="info-row">
                                <div className="label">Name:</div>
                                <div className="value">{selectedProduct.shipName}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">Address:</div>
                                <div className="value">{selectedProduct.shipAddress1}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">City:</div>
                                <div className="value">{selectedProduct.shipCity}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">State:</div>
                                <div className="value">{selectedProduct.shipState}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">Zip:</div>
                                <div className="value">{selectedProduct.shipZip}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">Phone:</div>
                                <div className="value">{selectedProduct.shipPhone}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">Email:</div>
                                <div className="value">{selectedProduct.shipEmail}</div>
                            </div>
                        </div>
                        <div className="details">
                            <h3>Detail:</h3>
                            <div className="info-row">
                                <div className="label">Order ID:</div>
                                <div className="value">{selectedProduct.uthealth_order_id}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">PO #:</div>
                                <div className="value">{!empty(selectedProduct.billPo) ? selectedProduct.billPo : 'N/A'}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">Platform:</div>
                                <div className="value">{platform.toUpperCase()}</div>
                            </div>
                            <div className="info-row">
                                <div className="label">Order Type:</div>
                                <div className="value">{selectedProduct.order_type}</div>
                            </div>
                            <div className="shipping-fields">
                                <div className="method-field">
                                    <div className="label">Method:</div>
                                    <select value={props.shippingMethod} onChange={(event) => props.setShippingMethod(event.target.value)}>
                                        <option value="">Select Option</option>
                                        <option value="FedEx">FedEx</option>
                                        <option value="UPS">UPS</option>
                                        <option value="USPS">USPS</option>
                                        <option value="Local delivery">Local delivery</option>
                                        <option value="Client pickup">Client pickup</option>
                                    </select>
                                </div>
                                <div className="tracking-field">
                                    <div className="label">Tracking #:</div>
                                    <input type="text" value={props.trackingNumber} onChange={(event) => props.setTrackingNumber(event.target.value)} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="list-container">
                        {renderTables()}
                    </div>
                    <div className="message-field">
                        <div>Message to Customer:</div>
                        <textarea placeholder="Enter your message." value={props.packingSlipMessage} onChange={(event) => props.setPackingSlipMessage(event.target.value)} />
                    </div>
                    <div className="thank-you">Thank you for your business.</div>
                </div>
            </div>
        </Dialog >
    );
});

export default PackingSlipModal;
